import React, {
    useState,
    useEffect,
} from "react"
import { StatsCard } from './ot'

const BaseChart2 = ({
    showComponent = [
        "StatsCard",
    ],
    baseStatsCard = {
        title: "範本總覽",
        stats: [
            {
                value: 125847,
                label: "範本總量",
                color: "#3b82f6",
                backgroundColor: "bg-blue-50",
                animationDuration: 2000,
                animationDelay: 0,
            },
            {
                value: 5,
                label: "服務分館",
                color: "#10b981",
                backgroundColor: "bg-green-50",
                animationDuration: 1500,
                animationDelay: 200,
            },
        ]
    },
}, ref) => {
    return (
        <>
            {
                showComponent.includes("StatsCard") && (
                    <StatsCard {...baseStatsCard} />
                )
            }
        </>
    )
}

export default BaseChart2
